export function EmptyState() {
  return (
    <section className="empty-state" aria-labelledby="empty-title">
      <h1 id="empty-title">무엇을 도와드릴까요?</h1>
      <p className="empty-state__copy">질문하고, 계획하고, 아이디어를 함께 발전시켜 보세요.</p>
    </section>
  );
}
